function GiftBox({ color, ribbon, filterId }) {
  return (
    <svg viewBox="0 0 100 120" width="100" height="120"
         xmlns="http://www.w3.org/2000/svg" overflow="visible"
         aria-hidden="true" focusable="false">
      <defs>
        <filter id={filterId} x="-20%" y="-20%" width="150%" height="150%">
          <feDropShadow dx="3" dy="6" stdDeviation="4" floodColor="rgba(0,0,0,0.5)" floodOpacity="1" />
        </filter>
      </defs>
      {/* Box body */}
      <rect x="8" y="38" width="84" height="75" rx="4" fill={color} filter={`url(#${filterId})`} />
      <rect x="12" y="38" width="11" height="75" fill="white" opacity="0.08" />
      {/* Lid */}
      <rect x="4" y="20" width="92" height="22" rx="4" fill={color} />
      <rect x="4" y="20" width="92" height="22" rx="4" fill="white" opacity="0.15" />
      <rect x="8" y="20" width="13" height="22" fill="white" opacity="0.10" />
      {/* Ribbon */}
      <rect x="44" y="20" width="12" height="93" fill={ribbon} />
      <rect x="4" y="28" width="92" height="10" fill={ribbon} />
      {/* Bow loops */}
      <ellipse cx="34" cy="18" rx="18" ry="10" transform="rotate(-35 34 18)" fill={ribbon} />
      <ellipse cx="66" cy="18" rx="18" ry="10" transform="rotate(35 66 18)" fill={ribbon} />
      {/* Bow knot */}
      <circle cx="50" cy="20" r="7" fill={ribbon} stroke="white" strokeWidth="0.8" strokeOpacity="0.3" />
      <circle cx="47" cy="18" r="2.5" fill="white" opacity="0.5" />
    </svg>
  );
}

const GIFTS = [
  // BL back
  { x: 60,   y: 820, size: 200, rotate: -8,  color: "#B71C1C", ribbon: "#FFD700" },
  { x: 180,  y: 830, size: 175, rotate: 12,  color: "#1A237E", ribbon: "#FF6B6B" },
  // BR back
  { x: 1380, y: 820, size: 190, rotate: 10,  color: "#B71C1C", ribbon: "#E8C96B" },
  { x: 1260, y: 830, size: 170, rotate: -12, color: "#1B5E20", ribbon: "#FFFFFF" },
  // BL mid
  { x: 100,  y: 720, size: 150, rotate: -15, color: "#1B5E20", ribbon: "#FFD700" },
  { x: 240,  y: 810, size: 185, rotate: 5,   color: "#6A1B9A", ribbon: "#E8C96B" },
  // BR mid
  { x: 1330, y: 720, size: 145, rotate: 14,  color: "#1A237E", ribbon: "#FF5252" },
  { x: 1190, y: 815, size: 180, rotate: -5,  color: "#00695C", ribbon: "#FFD700" },
  // BC
  { x: 680,  y: 860, size: 155, rotate: -4,  color: "#880E4F", ribbon: "#E8C96B" },
  { x: 760,  y: 840, size: 140, rotate: 9,   color: "#B71C1C", ribbon: "#FFFFFF" },
  { x: 820,  y: 870, size: 165, rotate: -11, color: "#1A237E", ribbon: "#FFD700" },
  { x: 620,  y: 845, size: 130, rotate: 16,  color: "#1B5E20", ribbon: "#FF6B6B" },
  { x: 900,  y: 855, size: 148, rotate: -3,  color: "#00695C", ribbon: "#E8C96B" },
  // BL front
  { x: 50,   y: 740, size: 130, rotate: 20,  color: "#00695C", ribbon: "#FF5252" },
  { x: 310,  y: 840, size: 160, rotate: -6,  color: "#E65100", ribbon: "#FFFFFF" },
  // BR front
  { x: 1420, y: 745, size: 125, rotate: -20, color: "#6A1B9A", ribbon: "#FF6B6B" },
  // BL top
  { x: 200,  y: 710, size: 120, rotate: 18,  color: "#880E4F", ribbon: "#FFD700" },
  // BR top
  { x: 1150, y: 710, size: 115, rotate: 8,   color: "#E65100", ribbon: "#FFD700" },
];

export default function GiftBackground() {
  return (
    <div className="gift-bg-layer">
      <svg
        viewBox="0 0 1440 900"
        preserveAspectRatio="xMidYMax slice"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {GIFTS.map((g, i) => {
          const scale = g.size / 100;
          return (
            <g
              key={i}
              transform={`translate(${g.x}, ${g.y}) rotate(${g.rotate}) scale(${scale}) translate(-50, -60)`}
            >
              <GiftBox color={g.color} ribbon={g.ribbon} filterId={`gift-shadow-${i}`} />
            </g>
          );
        })}
      </svg>
    </div>
  );
}
